<table class="default-report-template-table">
  <thead>
    <tr class="header-row">
      @for (item of columns; track item) {
        <th class="table-header" [sortable]="item" (sort)="onSort($event)">
          <div class="column-wrapper">
            <div class="header-name">
              <span>
                {{ item.replace('_', '') }}
              </span>
              @if (sortEvent && sortEvent.column === item) {
                <span class="sort-indicator">
                  @switch (sortEvent.direction) {
                    @case ('asc') {
                      <p>
                        ↓
                      </p>
                    }
                    @case ('desc') {
                      <p>
                        ↑
                      </p>
                    }
                  }
                </span>
              }
            </div>
          </div>
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of data; track row) {
      <tr class="table-row">
        @for (column of columns; track column) {
          <td class="table-column" [ngStyle]="{ width: 100 / columns.length + '%' }">
            {{ row[column] }}
          </td>
        }
      </tr>
    }
  </tbody>
</table>
